import { useState } from "react";
import { forgotPassword } from "./AuthService";
import "./ForgotPassword.css";

export default function ForgotPassword(){

  const [username,setUsername] = useState("");

  const submit = async (e)=>{
    e.preventDefault();
    await forgotPassword(username);
    alert("Password reset link sent");
  };

  return (
    <form onSubmit={submit} className="forgot-password-form">
      <h2>Forgot Password</h2>

      <input
        className="forgot-password-input"
        placeholder="Username or Email"
        onChange={e=>setUsername(e.target.value)}
        required
      />
      <button className="btn btn-primary forgot-password-btn" type="submit">Send Reset Link</button>
    </form>
  );
}
